import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';

import EditUserEmail from 'shared/modules/account/components/organisms/EditUserEmail';
import EditUserPhone from 'shared/modules/account/components/organisms/EditUserPhone';
import UserEmail from 'shared/modules/account/components/organisms/UserEmail';
import UserPhone from 'shared/modules/account/components/organisms/UserPhone';
import {
  ACTION,
  ITEM,
  ORIGIN,
  SCREEN,
} from 'shared/modules/account/constants/mixpanel';
import Dialog from 'shared/modules/common/components/atoms/Dialog';
import Mixpanel from 'shared/vendor/Mixpanel';

const ACCOUNT_CLICK_EVENT = `${SCREEN.ACCOUNT} - ${ACTION.CLICK}`;
const EMAIL_RESET_EVENT = `${SCREEN.EMAIL_RESET_FORM} - ${ACTION.PAGE_VIEW}`;
const PHONE_RESET_EVENT = `${SCREEN.PHONE_RESET_FORM} - ${ACTION.PAGE_VIEW}`;

const SignInDetails = () => {
  const [isEditEmailOpen, openEditEmail] = useState(false);
  const [isEditPhoneOpen, openEditPhone] = useState(false);

  return (
    <>
      <UserEmail
        onEditButtonPress={() => {
          Mixpanel.trackEvent(`${SCREEN.ACCOUNT} - ${ACTION.CLICK}`, {
            Item: ITEM.SIGNIN_INFO,
          });

          openEditEmail(true);
        }}
      />
      <View style={styles.separator} />
      <UserPhone
        onEditButtonPress={() => {
          Mixpanel.trackEvent(ACCOUNT_CLICK_EVENT, {
            Item: ITEM.SIGNIN_INFO,
          });

          openEditPhone(true);
        }}
      />
      <Dialog
        title="メールアドレスの変更"
        open={isEditEmailOpen}
        onOpen={() => Mixpanel.timeEvent(EMAIL_RESET_EVENT)}
        onCloseButtonPress={() => openEditEmail(false)}
        onClose={() => Mixpanel.trackEvent(EMAIL_RESET_EVENT)}
        style={styles.dialog}
        id="edit-email-dialog"
      >
        <EditUserEmail onSuccess={() => openEditEmail(false)} />
      </Dialog>
      <Dialog
        title="携帯電話番号の変更"
        open={isEditPhoneOpen}
        onOpen={() => Mixpanel.timeEvent(PHONE_RESET_EVENT)}
        onCloseButtonPress={() => openEditPhone(false)}
        onClose={() =>
          Mixpanel.trackEvent(PHONE_RESET_EVENT, {
            Item: ORIGIN.ACCOUNT,
          })
        }
        style={styles.dialog}
        id="edit-phone-dialog"
      >
        <EditUserPhone onSuccess={() => openEditPhone(false)} />
      </Dialog>
    </>
  );
};

const styles = StyleSheet.create({
  separator: {
    height: 16,
  },
  dialog: {
    width: 424,
    minHeight: 488,
  },
});

export default SignInDetails;
